import { render } from "./RsuForm.vue?vue&type=template&id=1b2274e4&scoped=true"
import script from "./RsuForm.vue?vue&type=script&lang=js"
export * from "./RsuForm.vue?vue&type=script&lang=js"

import "./RsuForm.vue?vue&type=style&index=0&id=1b2274e4&lang=scss&scoped=true"
import "./RsuForm.vue?vue&type=style&index=1&id=1b2274e4&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2274e4"]])

export default __exports__